export default "__VITE_ASSET__tmVbWoJe__"